<template>
  <div class="backUpPlanSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="backupPlanName"
          :placeholder="$t('RAM.common.QueryByBackupPlanName')"
        />
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:aws:backup:serverlessReplications:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../../utils/cookieUtil";
import TableBackupPlan from "../plan/TableBackupPlan";
var tableBackupPlan = TableBackupPlan;
export default {
  name: "BackUpPlanSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyIdList: [],
      accountName: "",
      backupPlanName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableBackupPlan.methods.showAll();
    }
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("backupPlanName", this.backupPlanName);
      tableBackupPlan.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
      });
    }
  }
};
</script>
<style scoped>
.backUpPlanSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/backup/plan/BackupPlanSearch.vue